<div class="flex flex-wrap gap-2 mb-2">
  @for (tag of value; track tag) {
    <ui-badge [variant]="variant" className="inline-flex items-center max-w-full min-w-0" size="lg">
      <div class="flex items-center gap-2 w-full min-w-0">
        <span class="truncate max-w-[18rem]" [title]="tag">{{ tag }}</span>
        <button
          type="button"
          class="btn btn-ghost btn-xs btn-circle ml-auto"
          [attr.aria-label]="'Remove tag ' + tag"
          (click)="removeTag(tag)"
          [disabled]="disabled">
          &times;
        </button>
      </div>
    </ui-badge>
  }
</div>

<ui-input
  type="text"
  [placeholder]="placeholder"
  [value]="newTag"
  (valueChange)="setNewTag($event)"
  (keydown)="handleKeyDown($event)"
  (paste)="handlePaste($event)"
  (focused)="onFocus()"
  (blurred)="onBlur()"
  [disabled]="disabled"
  [clearable]="true"
  [fullWidth]="true"
  ariaLabel="Tags input"
  [className]="showPendingAsError ? 'validator input-error' : (showPendingAsWarning ? 'validator input-warning' : '')"
  hint="Press enter to commit this value"
  [showHint]="showPendingHint"
  [forceInvalid]="showPendingHint">
</ui-input>
